import { render, staticRenderFns } from "./DedicationSales.vue?vue&type=template&id=18dfbdb8&scoped=true&"
import script from "./DedicationSales.vue?vue&type=script&lang=js&"
export * from "./DedicationSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfbdb8",
  null
  
)

export default component.exports